var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "selected-filters clearfix d-flex flex-nowrap flex-lg-wrap overflow-auto",
    },
    [
      _vm._l(_vm.tagList, function (tag) {
        return _c(
          "span",
          {
            key: tag.id,
            class: "selected-filter filter-" + tag.id,
            attrs: {
              rel: "nofollow",
              "aria-label":
                _vm.facetInfo[tag.id].name +
                ":" +
                tag.name +
                " " +
                _vm.$translate("Ceres::Template.itemFilterReset"),
              role: "button",
              tabindex: "0",
            },
            on: {
              click: function ($event) {
                return _vm.removeTag(tag)
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.removeTag(tag)
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.removeTag(tag)
              },
            },
          },
          [
            _vm.facetInfo[tag.id]
              ? _c("span", { staticClass: "text-nowrap" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.facetInfo[tag.id].name) +
                      ": " +
                      _vm._s(tag.name) +
                      "\n      "
                  ),
                  _c("i", {
                    staticClass: "fa fa-times",
                    attrs: { "aria-hidden": "true" },
                  }),
                ])
              : _c("span", { staticClass: "text-nowrap" }, [
                  _vm._v("\n      " + _vm._s(tag.name) + "\n      "),
                  _c("i", {
                    staticClass: "fa fa-times",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]),
          ]
        )
      }),
      _vm._v(" "),
      _vm.tagList.length >= 2
        ? _c(
            "span",
            {
              staticClass: "selected-filter reset-all text-nowrap",
              attrs: {
                rel: "nofollow",
                role: "button",
                "aria-label": _vm.$translate("Ceres::Template.itemFilterReset"),
                tabindex: "0",
              },
              on: {
                click: function ($event) {
                  return _vm.resetAllTags()
                },
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.resetAllTags()
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.resetAllTags()
                },
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$translate("Ceres::Template.itemFilterReset")) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }